import { Fragment } from "react/jsx-runtime";
import { ScoreRating } from "~/operations";
import { Grid, TableCell, TableRow } from "@mui/material";
import { ImpactCell, PublishedCell, TitleCell } from "~/components/Cells";
import { GenericTable } from "~/components/GenericTable/GenericTable";
import { ReportsNoItemsSection } from "../../components";
import { UseCveOrAdvisoryReportReturnObject } from "../hooks/useCveOrAdvisoryReport";
import { ReportsSectionHeading } from "~/pages/reports/components/ReportsSectionHeading";

interface ContentDetailsProps {
  vulnerabilities: UseCveOrAdvisoryReportReturnObject["data"]["vulnerabilities"];
}

export function CveOrAdvisoryReportContentDetails({
  vulnerabilities,
}: ContentDetailsProps) {
  const hasVulnerabilities = Boolean(vulnerabilities?.length);

  return (
    <Fragment>
      <ReportsSectionHeading heading="Content details" disableUpperPadding />
      <Grid size={12} sx={{ my: 3 }}>
        {!hasVulnerabilities ? (
          <ReportsNoItemsSection target="vulnerabilities" />
        ) : (
          <GenericTable
            items={0}
            tableName="ASSET_REPORT_VULNERABILITIES"
            validSortFields={[]}
            printView
          >
            {vulnerabilities?.map((node) => {
              return (
                <TableRow key={node?.id}>
                  <ImpactCell
                    impact={node?.riskValue || 0}
                    rating={node?.rating || ScoreRating.Critical}
                    isActive
                  />
                  <TitleCell
                    title={node?.id || ""}
                    options={{ fontSize: 14 }}
                  />
                  <TableCell></TableCell>
                  {/* <RiskFactorsCell
                    riskFactors={node?.vulnerabilityRiskFactors}
                    printView
                  /> */}
                  <PublishedCell
                    date={node?.publishedAt || "Never"}
                    formatting="absolute"
                  />
                </TableRow>
              );
            })}
          </GenericTable>
        )}
      </Grid>
    </Fragment>
  );
}
